import I from '../types.ts';

const updatePagesKey: I['updatePagesKey'] = function () {
    this.setState({ updatedPagesKey: new Date().getTime() });
};

export default updatePagesKey;
